import { UseFormReturn } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../../ui/components/ui/form";
import { Input } from "../../../ui/components/ui/input";
import { OnboardingFormData } from "../onboarding-schema";

interface PersonalDataStepProps {
  form: UseFormReturn<OnboardingFormData>;
}

const PersonalDataStep = ({ form }: PersonalDataStepProps) => {
  return (
    <div>
      <p className="text-sm font-medium mb-1" style={{ color: "#0099ce" }}>
        Schritt 1 von 9
      </p>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Ihre persönlichen Daten</h1>
      <p className="text-sm text-gray-500 mb-6">
        Bitte geben Sie Ihren Vor- und Nachnamen ein, damit wir Ihr Profil korrekt anlegen können.
      </p>

      <div className="rounded-xl bg-white shadow-sm border border-gray-100 p-8">
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-sm font-medium text-gray-700">
                  Vorname <span className="text-red-500">*</span>
                </FormLabel>
                <FormControl>
                  <Input {...field} placeholder="z.B. Max" className="mt-1" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="lastName"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-sm font-medium text-gray-700">
                  Nachname <span className="text-red-500">*</span>
                </FormLabel>
                <FormControl>
                  <Input {...field} placeholder="z.B. Mustermann" className="mt-1" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalDataStep;
